import { render, staticRenderFns } from "./BaseInputFileWithPreview.vue?vue&type=template&id=028c24e3&scoped=true&"
import script from "./BaseInputFileWithPreview.vue?vue&type=script&lang=ts&"
export * from "./BaseInputFileWithPreview.vue?vue&type=script&lang=ts&"
import style0 from "./BaseInputFileWithPreview.vue?vue&type=style&index=0&id=028c24e3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028c24e3",
  null
  
)

export default component.exports